import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import Cookies from '../Pages/Cookies'

function CookiesLayout() {
  return (
    <>
    <Header />
    <Cookies />
    <Footer />
    </>
  )
}

export default CookiesLayout